import { dataCustomer } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCustomer = /*#__PURE__*/createIcon(dataCustomer)
export default IconCustomer
